import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0b48139c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex justify-space-between text-body-2" }
const _hoisted_2 = { class: "font-weight-bold" }
const _hoisted_3 = { class: "text-medium-emphasis" }
const _hoisted_4 = { class: "d-flex text-caption mt-1 ga-3" }
const _hoisted_5 = { class: "text-success" }
const _hoisted_6 = { class: "text-medium-emphasis" }
const _hoisted_7 = { class: "text-error" }
const _hoisted_8 = {
  key: 0,
  class: "barra mt-1"
}


import { Balance } from "@/utils/historialJugador";


export default /*#__PURE__*/_defineComponent({
  __name: 'BarraBalance',
  props: {
    titulo: {},
    balance: {}
  },
  setup(__props: any) {

const props = __props;

const ancho = (n: number) => `${(n / props.balance.total) * 100}%`;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.titulo), 1),
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.balance.total) + " " + _toDisplayString(_ctx.balance.total === 1 ? "partida" : "partidas") + " · " + _toDisplayString(_ctx.balance.porcentaje) + "% de victorias ", 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.balance.victorias) + " V", 1),
      _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.balance.empates) + " E", 1),
      _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.balance.derrotas) + " D", 1)
    ]),
    (_ctx.balance.total > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", {
            class: "bg-success",
            style: _normalizeStyle({ width: ancho(_ctx.balance.victorias) })
          }, null, 4),
          _createElementVNode("div", {
            class: "bg-grey",
            style: _normalizeStyle({ width: ancho(_ctx.balance.empates) })
          }, null, 4),
          _createElementVNode("div", {
            class: "bg-error",
            style: _normalizeStyle({ width: ancho(_ctx.balance.derrotas) })
          }, null, 4)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})